<!-- 腾讯推广账户 / 腾讯账户下拉  -->
<template>
<a-select
	style="width: 550px;"
	placeholder="请选择腾讯广告账户"
	:filter-option="false"
	@change="handleChangeC"
	:getPopupContainer="getsPopupContainer" 
	@popupScroll="popupScrollTxAcc" 
	showSearch
	allowClear
	@search="selectTxSearch"
	:not-found-content="t_fetching ? undefined : null" 
	@blur="txBlur" 
	:value="txSelectValue"
  >
	<a-spin v-if="t_fetching" slot="notFoundContent" size="small" />
	<a-select-option v-for="(item,index) in selectTxGg" :key="item.account_id" :value="item.account_id" :title="item.account_name">
		<span>ID：{{item.account_id}}（账户名称：{{item.account_name || '无'}}）</span>
	</a-select-option>
	
	<a-select-option v-if="t_loading_more_hint" value="-0-">
		<div style="color:rgb(98, 168, 234)">加载更多中...</div>
	</a-select-option>
</a-select>
</template>

<script>
import { MPggSelectAcc } from '@/request/api'
export default {
	name: 'txAccSelect_',
	components: {
		
	},
	data() {
		return {
			// 腾讯-广告账户下拉列表
			selectTxGg: [], // 选择广告账户
			blurTxGg: [], // 保存一份，用于失去焦点后，回复原来的数值
			t_page: 1,
			t_limit: 100,
			t_account_name: "", // 下拉选择框的搜索字段
			t_fetching: false, // 用于控制提示
			t_loading_more_control: true, // 上拉加载更多控制
			t_loading_more_hint: false, // 上拉加载更多的提示
			
			txSelectValue: undefined, // 腾讯账户下拉
		}
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		closeValue(){
			this.txSelectValue = undefined
		},
		getSelectData(acc_id){
			let that = this
			that.txSelectValue = acc_id || undefined
			
			let r_data = {
				page: 1,
				limit: that.t_limit,
			}
			if(acc_id){
				r_data.account_id = acc_id // 为了避免出来的内容不在第一页，无法再组件中展示，所以加上这个字段后，后端可以把这个内容在第一页进行返回，下拉框组件上就能显示了
			}
			// 获取腾讯广告下拉
			MPggSelectAcc(r_data).then(res=>{
				console.log("获取腾讯广告下拉",res.data.data.data);
				let data = res.data.data.data
				
				// 数组对象去重，去除数组对象中的重复内容
				function uniqueFunc(arr, uniId){
				  const res = new Map();
				  return arr.filter((item) => !res.has(item[uniId]) && res.set(item[uniId], 1));
				}
				// console.log("uniqueFunc",uniqueFunc(data,'account_id'));
				
				that.selectTxGg = uniqueFunc(data,'account_id')
				that.blurTxGg = uniqueFunc(data,'account_id')
			})
		},
		// 腾讯推广账户下拉
		handleChangeC(value){
			this.txSelectValue = value
			this.$emit('select-handle',value)
		},
		// 腾讯广告账户下拉-开始
		// select选择器下拉加载更多功能实现
		popupScrollTxAcc(e){ // 上拉触底加载更多
			if(e.target.scrollHeight - e.target.scrollTop < 300){ // 上拉触底加载更多
				if(this.t_loading_more_control){ // 节流，保证这期间只执行一次
					this.t_loading_more_hint = true
					this.t_loading_more_control = false
					let that = this
					that.t_page = that.t_page + 1
					console.log("上拉触底加载更多");
					MPggSelectAcc({
						page: that.t_page,
						limit: that.t_limit,
						// account_name: that.t_account_name,
						// 因为这个广告名字都一样，就ID不同，所以这个字段可以名字、ID一起搜
						name_id_select: that.t_account_name, 
					}).then(res=>{
						console.log('选择',res);
						
						let data = that.selectTxGg 
						that.t_loading_more_hint = false
						that.t_fetching = false
						that.t_loading_more_control = true
						
						let m_data = data.concat(res.data.data.data) 
						// 数组对象去重，去除数组对象中的重复内容
						function uniqueFunc(arr, uniId){
						  const res = new Map();
						  return arr.filter((item) => !res.has(item[uniId]) && res.set(item[uniId], 1));
						}
						that.selectTxGg = uniqueFunc(m_data,'account_id')
					})
				}
			}
		},
		// 选择框搜索-选择广告账户
		selectTxSearch(e){
			console.log("选择框搜索",e);
			let that = this
			that.selectTxGg = []
			that.t_fetching = true
			that.t_account_name = e
			
			MPggSelectAcc({
				page: 1,
				limit: that.t_limit,
				// account_name: e,
				name_id_select: e,
			}).then(res=>{
				console.log('选择',res);
				that.t_page = 1
				that.selectTxGg = res.data.data.data
				that.t_fetching = false
			})
		},
		// 失去焦点
		txBlur(e){
			let that = this
			console.log("失去焦点",e);
			that.t_page = 1
			that.t_account_name = '' // 清空
			that.selectTxGg = that.blurTxGg 
		},
		// 腾讯广告账户下拉-结束
	}
}
</script>

<style>
</style>